/*
  Consent status tracking:
  - fetch initial value, as user may have consented on a previous visit.
  - monitor for consent status changing on this visit, as this occurs when
    the user clicks the buttons presented on the consent pop-up dialog.
 */
import { consentStatus, observeConsentStatusChange, THE_CONVERSATION_VENDOR_ID, } from "@theconversation/shared-components/Didomi";
import { didomiIsEnabled } from "./globalConfig";
import { doNotPersistDeviceId, persistDeviceId, } from "@theconversation/shared-components/tcEventsCollector";
function consentStatusCallback(consent) {
    console.log(`GDPR Consent Callback called with: ${consent}`);
    if (consent)
        persistDeviceId();
    else
        doNotPersistDeviceId();
}
function setInitialDidomiUserStatus() {
    // If Didomi isn't even enabled, default to true
    if (!didomiIsEnabled()) {
        consentStatusCallback(true);
        return;
    }
    consentStatus({
        vendorId: THE_CONVERSATION_VENDOR_ID,
        purpose: "measure_content_performance",
    }).then((consent) => consentStatusCallback(consent));
}
// This must be called to initialise the Didomi callbacks when the status changes.
let tcEventGdprConsentStatusSetupComplete = false;
export function setupTcEventGdprConsentStatus() {
    if (tcEventGdprConsentStatusSetupComplete)
        return;
    setInitialDidomiUserStatus();
    observeConsentStatusChange(async () => {
        const userIsEligibleToTrackStatus = await consentStatus({
            vendorId: THE_CONVERSATION_VENDOR_ID,
            purpose: "measure_content_performance",
        });
        consentStatusCallback(userIsEligibleToTrackStatus);
    });
    tcEventGdprConsentStatusSetupComplete = true;
}
